import React from 'react';

function CustomZoomImage() {
  return <></>;
}

export default React.memo(CustomZoomImage);
